/* 
  Used for the colouring of the quality css on reports table via class names
  < input = category >
  < output = quality className > 
 */

export function getQualityClassName(quality) {

  // Low Quality ( 0 - 3 )
  if (quality >= 0 && quality <= 3) {
    return "low-quality";
  } 
  
  // Meduim Quality ( 4 - 7 )
  else if (quality >= 4 && quality <= 7) {
    return "medium-quality";
  } 

  // High Quality ( 8 - 10 )
  else if (quality >= 8 && quality <= 10) {
    return "high-quality";
  } 
  
  // Unknown Quality
  else {
    return "unknown-quality";
  }
}
